import React from 'react';
import { NavigationHeaderWrapper } from 'features/GuestReschedule/components/Layout';
import { NavigationHeader as NavigationHeaderComponent } from 'components/NavigationHeader';
import { useHistory } from 'react-router-dom';

const NavigationHeader = () => {
  const { goBack } = useHistory();

  return (
    <NavigationHeaderWrapper>
      <NavigationHeaderComponent
        preventDefaultBack
        onGoBack={goBack}
        showCart={false}
        style={{
          marginBottom: '0px',
          height: '40px',
        }}
      />
    </NavigationHeaderWrapper>
  );
};

export default NavigationHeader;
